import { Center } from '@mantine/core';
import classes from './VictoryLiveLogoHover.module.css';

interface LogoProps {
  size?: number;
}

export default function VictoryLiveLogoHover({ size = 60 }: LogoProps) {
  return (
    <Center className={classes.victoryLiveHoverableLogo}>
      <svg width={size} viewBox="0 0 2769 462" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M446.393 0H311.794H310.517L288.794 101.801L241.087 309.236L193.808 101.801L172.085 0H170.806H36.2083H32.8008L241.087 415.296L449.8 0H446.393Z"
          fill="var(--colors-victoryLivePrimary)"
        />
        <path d="M461.724 91.9968L240.659 453.198L19.1675 91.9968L0 198.483L240.659 461.716L480.891 198.483L461.724 91.9968Z" fill="var(--colors-victoryLiveAccent)" />
        <path
          d="M686.62 326.285L598.024 135.462H618.043L667.453 242.374C685.343 281.561 692.584 298.173 696.417 308.395H696.844C699.825 299.877 711.751 273.894 722.4 250.467L776.069 135.462H796.088L706.214 326.285H686.62Z"
          fill="var(--colors-victoryLivePrimary)"
        />
        <path d="M861.693 135.462V326.285H842.951V135.462H861.693Z" fill="var(--colors-victoryLivePrimary)" />
        <path
          d="M1110.87 272.61C1098.52 304.981 1075.09 330.112 1021.85 330.112C958.805 330.112 922.601 287.092 922.601 231.293C922.601 175.494 963.065 131.195 1022.7 131.195C1077.64 131.195 1102.78 159.734 1111.72 190.402H1092.13C1081.48 166.123 1063.59 147.381 1022.27 147.381C973.287 147.381 942.194 182.309 942.194 230.441C942.194 278.572 973.714 313.5 1022.7 313.5C1064.01 313.5 1079.77 296.036 1092.13 272.183H1110.87V272.61Z"
          fill="var(--colors-victoryLivePrimary)"
        />
        <path d="M1223.31 152.074H1145.79V135.462H1320V152.074H1242.48V326.285H1223.74V152.074H1223.31Z" fill="var(--colors-victoryLivePrimary)" />
        <path
          d="M1548.3 230.439C1548.3 284.959 1509.97 330.536 1446.93 330.536C1383.89 330.536 1344.71 286.238 1344.71 230.439C1344.71 177.197 1385.59 131.62 1446.93 131.62C1508.27 131.62 1548.3 177.197 1548.3 230.439ZM1364.73 229.161C1364.73 272.608 1393.69 313.924 1447.36 313.924C1501.03 313.924 1528.71 277.293 1528.71 230.865C1528.71 188.696 1498.9 147.806 1445.66 147.806C1396.25 147.806 1364.73 185.289 1364.73 229.161Z"
          fill="var(--colors-victoryLivePrimary)"
        />
        <path
          d="M1626.68 240.244V326.285H1607.94V135.462H1695.67C1733.59 135.462 1761.28 151.648 1761.28 186.149C1761.28 208.299 1750.63 225.762 1724.65 231.726C1739.97 235.559 1756.16 245.782 1756.16 279.006V286.672C1756.16 302.006 1756.16 318.619 1758.29 326.285H1739.55C1736.57 318.192 1737.42 302.006 1737.42 287.951V281.561C1737.42 249.189 1724.22 240.244 1687.15 240.244H1626.68ZM1626.68 223.633H1690.57C1724.65 223.633 1742.11 212.132 1742.11 186.149C1742.11 162.722 1724.65 151.222 1691.85 151.222H1626.68V223.206V223.633Z"
          fill="var(--colors-victoryLivePrimary)"
        />
        <path
          d="M1879.69 326.285V251.745C1879.69 251.745 1879.26 249.189 1877.99 247.485L1795.36 135.462H1817.5C1842.21 169.538 1880.96 219.8 1889.48 234.707C1899.28 219.373 1935.91 169.111 1960.62 135.462H1981.91L1899.71 247.485C1899.71 247.485 1898.43 249.615 1898.43 251.745V326.285H1879.69Z"
          fill="var(--colors-victoryLivePrimary)"
        />
        <path d="M2016 138.005H2073.5V284.53H2178.71L2171.9 326.272H2016V138.005Z" fill="var(--colors-victoryLivePrimary)" />
        <path d="M2282.63 138.005V326.272H2225.12V138.005H2282.63Z" fill="var(--colors-victoryLivePrimary)" />
        <path
          d="M2404.04 326.272L2327.36 138.005H2390.4L2420.64 223.619C2431.72 255.564 2436.83 273.029 2439.82 285.807H2440.24C2443.22 273.881 2444.92 267.492 2461.96 219.786L2490.07 138.005H2551.84L2473.88 326.272H2404.04Z"
          fill="var(--colors-victoryLivePrimary)"
        />
        <path
          d="M2756.29 250.027H2651.51V284.53H2768.64L2762.25 326.272H2594.86V138.005H2762.25V179.747H2651.93V208.285H2756.72V250.027H2756.29Z"
          fill="var(--colors-victoryLivePrimary)"
        />
      </svg>
    </Center>
  );
}
